/**
 * this module override
 * vse style to show only
 * the application and apply style for V1E
 */
import './uiBuilder.css';

import { setEnvironment } from '@vse/environment';
import { standalone } from '@vse/main';

/**
 * @param {Library} library The MachineLogicLibrary
 * @param {Navigate} navigate A function to navigate to another page.
 * @returns {void} Nothing.
 */
export function initializeUiBuilder (library, navigate) {
  setEnvironment('pendant', 'uibuilder');

  const uiBuilderContainer = $("<div id='main' class='h_layout spaced ui_builder_page'>");
  const leftPane = $("<div id='left_pane' class='v_layout'>");
  const rightPane = $("<div id='right_pane' class='v_layout'>");

  $('#guiContainer')
    .addClass('v_layout spaced')
    .append(
      uiBuilderContainer.append(
        leftPane,
        rightPane,
      ),
    );

  standalone(library, navigate);
}
